import { Vector3, Color4, Vector2, Scene, ArcRotateCamera, Matrix, AbstractMesh, Quaternion } from '@babylonjs/core';
import { Ellipse, AdvancedDynamicTexture, Control, Rectangle, Image, StackPanel,Button } from '@babylonjs/gui';
import { GlobalObject } from '../../utils/GlobalObject';
import { Boardcaster } from './../../event/Boadcaster';

export class Menu {
    private static _instance: Menu;
    private gui: AdvancedDynamicTexture;
    private mc?: Rectangle;
    private menus?: Image[];
    private views?: Image[];
    private back?: Image;
    private source?: any;
    private isShow = true;
    private bc = new BroadcastChannel("hql23"); // Boardcaster.getInstance();

    constructor() {
        let gui = GlobalObject.getInstance().main.gui;
        if (gui) {
            this.gui = gui;
        } else {
            this.gui = AdvancedDynamicTexture.CreateFullscreenUI("UI");
            this.gui.idealWidth = 1000;
        }
        this.source = GlobalObject.getInstance().main.source.menu;
        this.initUI();
    }
    public static getInstance() {
        if (!this._instance) this._instance = new Menu();
        return this._instance;
    }
    private initUI() {
        this.mc = new Rectangle();
        // mc左上角对齐, mc的原点也在屏幕左上角。给mc设置top,left，mc会相对屏幕左上角偏移对应的距离。
        this.mc.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.mc.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this.mc.width = "1000px";
        this.mc.height = "100%";
        this.mc.color = "#ffcc0000";
        this.mc.top = 0;
        this.mc.left = 0;
        this.gui.addControl(this.mc);
        //this.mc.isPointerBlocker = true;  // 允许鼠标交互
        this.menus = [];
        this.views = [];

        this.back = new Image("backImg", this.source.back);
        this.back.isVisible = false;
        this.back.width = "28px";
        this.back.height = "10px";
        this.back.top = "45%";
        this.back.left = "450px";
        this.mc.addControl(this.back);
        this.back.onPointerClickObservable.add((evt) => {
            // console.log(menu.target.metadata.id);
            let msg = { type: "backFactoryFromEquipment" }
            this.bc.postMessage(msg);
        });
        this.back.onPointerEnterObservable.add(() => {
            document.body.style.cursor='pointer'; // 光标改成手型
        })
        this.back.onPointerOutObservable.add(() => {
            document.body.style.cursor=''; // 光标改成默认箭头
        })

        let topBg = new Image("topBg", this.source.topBg);
        topBg.width = "100%";
        topBg.height = "5.1%";
        topBg.top = "-47.51%";
        topBg.left = 0;
        this.mc.addControl(topBg);

        let bottomBg = new Image("bottomBg", this.source.bottomBg);
        bottomBg.width = "76.5%";
        bottomBg.height = "5.1%";
        bottomBg.top = "47.51%";
        bottomBg.left = 0;
        this.mc.addControl(bottomBg);

        for (let i = 1; i < 7; ++i) {
            let menu = new Image("menu" + i, this.source['menu' + i]);
            menu.width = "36px";
            menu.height = "32px";
            menu.top = "45%";
            menu.left = (-180 + i * 50) + "px";
            menu.metadata = {};
            menu.metadata.id = i;
            this.menus.push(menu);
            this.mc.addControl(menu);
            menu.onPointerClickObservable.add((evt, menu) => {
                // console.log(menu.target.metadata.id);
                let msg = { type: "workshopChanged", data: menu.target.metadata.id }
                this.bc.postMessage(msg);
            });
            menu.onPointerEnterObservable.add(() => {
                document.body.style.cursor='pointer'; // 光标改成手型
            });
            menu.onPointerOutObservable.add(() => {
                document.body.style.cursor=''; // 光标改成默认箭头
            });
            if (i < 5) {
                let view = new Image("view" + i, this.source['view' + i]);
                view.width = "24px";
                view.height = "24px";
                view.top = (30 + i * 30) + "px";
                view.left = "450px";
                view.metadata = {};
                view.metadata.id = i;
                this.views.push(view);
                this.mc.addControl(view);
                view.onPointerClickObservable.add((evt, view) => {
                    // console.log(menu.target.metadata.id);
                    let msg = { type: "viewAngleChanged", data: view.target.metadata.id }
                    this.bc.postMessage(msg);
                });
                view.onPointerEnterObservable.add(() => {
                    document.body.style.cursor='pointer'; // 光标改成手型
                });
                view.onPointerOutObservable.add(() => {
                    document.body.style.cursor=''; // 光标改成默认箭头
                });
            }
        }


        /*

        this.pt = new Image("navi_point", this.source.pt);
        this.pt.width = "18px";
        this.pt.height = "18px";
        this.pt.top = 0;
        this.pt.left = 0;
        this.mc.addControl(this.pt);

        this.northDir = new Image("north_direction", this.source.nDir);
        this.northDir.width = "8px";
        this.northDir.height = "9.6px";
        this.northDir.top = -40;
        this.northDir.left = -40;
        this.mc.addControl(this.northDir);
        this.hide();
        */

        //this.loadImg();
    }
    public changeBackBtn(val: boolean = true) {
        if (!this.back) {
            return;
        }
        this.back.isVisible = val;
    }
    public hide() {
        this.isShow = false;
        (this.mc as Rectangle).isVisible = false;
        console.log('hide mini map');
    }
    public show() {
        this.isShow = true;
        (this.mc as Rectangle).isVisible = true;
    }
}